export var Gender;
(function (Gender) {
    Gender["Female"] = "FEMALE";
    Gender["Male"] = "MALE";
    Gender["Undisclosed"] = "UNDISCLOSED";
    Gender["Unknown"] = "UNKNOWN";
})(Gender || (Gender = {}));
//# sourceMappingURL=Gender.js.map